export default __webpack_public_path__ + "media/images/warning-stripes-9bb6a826bc6215da538d09fe7e6c1917.svg";